import { type ReactNode } from 'react';
import { CheckIcon } from '@phosphor-icons/react';
import clsx from 'clsx';

// Brand-styled checkbox: 20px box, subtle fill that flips to green-soft
// on check, green Phosphor checkmark, soft green focus ring. Renders inside
// a wrapping <label> so clicking the label text toggles the box.

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: ReactNode;
  disabled?: boolean;
  /** Applied to the wrapping <label>. */
  className?: string;
}

export function Checkbox({
  checked,
  onChange,
  label,
  disabled,
  className,
}: CheckboxProps) {
  return (
    <label
      className={clsx(
        'inline-flex items-center gap-2 text-sm text-fg-secondary cursor-pointer select-none',
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="peer sr-only"
      />
      <span
        className={clsx(
          'w-5 h-5 rounded grid place-content-center transition-colors',
          'peer-focus-visible:ring-2 peer-focus-visible:ring-green-soft',
          checked ? 'bg-green-soft' : 'bg-subtle',
          disabled && 'cursor-not-allowed'
        )}
      >
        {checked && <CheckIcon size={14} weight="bold" className="text-green" />}
      </span>
      {label}
    </label>
  );
}
